import React, { useState } from 'react'
import '../../../styles/Billing.css';
import BillingAddress from './BillingAddress';
import Cookies from 'js-cookie';
import SubscriptionDetails from './SubscriptionDetails';
import Invoice from './Invoice';
import ACHDetails from './ACHDetails';
import CreditCardDetails from './CreditCardDetails';
import UpdateBillingAddress from './UpdateBillingAddress';
import AddCreditCard from './AddCreditCard';
import UpgradeSubscription from './UpgradeSubscription';
import UpgradePlan from './UpgradePlan';
import { useTheme } from '../../../components/hooks/useTheme';
import useAuth from '../../../components/hooks/useAuth';
import AddACH from './AddACH';
import { post_RenewSubscription, post_UpgradeSubscription } from '../../../services/subscription/checkout';
import useConfirm from '../../../components/hooks/useConfirm';
import useTenant from '../../../components/hooks/useTenant';

const Billing = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError, setRefreshTheSubscription }: any = useTenant();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();

  const { themeStyles } = useTheme();

  // Billing Address
  const [billingAddressData, setBillingAddressData] = useState<any>({
    name: "",
    emailAddress: "",
    phoneNumber: "",
    street: "",
    street2: "",
    zip: "",
    state: "",
    city: "",
    country: ""
  });
  const [showPopupUpdateBillingAddress, setShowPopupUpdateBillingAddress] = useState<boolean>(false);


  // Credit Card Details  
  const [isRefreshCreditCardDetails, setIsRefreshCreditCardDetails] = useState<boolean>(true);
  const [showPopupAddNewCreditCard, setShowPopupAddNewCreditCard] = useState<boolean>(false);


  // Bank ACH Details  
  const [isRefreshACHDetails, setIsRefreshACHDetails] = useState<boolean>(true);
  const [showPopupAddNewACH, setShowPopupAddNewACH] = useState<boolean>(false);


  // Upgrade Subscription 
  const [planDetails, setPlanDetails] = useState<any | null>(null);
  const [upgradPlan, setUpgradePlan] = useState<any | null>(null);
  const [activePaymentDetails, setActivePaymentDetails] = useState<any | null>(null);
  const [showPopupUpgradeSubscription, setShowPopupUpgradeSubscription] = useState<boolean>(false);
  const [isRefreshSubscriptionDetails, setIsRefreshSubscriptionDetails] = useState<boolean>(true);

  const [paymentType, setPaymentType] = useState<number>(0);
  const [isUpgradingTheSubcription, setIsUpgradingTheSubcription] = useState<boolean>(false);
  const [showPopupForPayment, setShowPopupForPayment] = useState<boolean>(false);


  // Invoice
  const [isRefreshInvoice, setIsRefreshInvoice] = useState<boolean>(true);

  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const callTheAPIForUpgradeSubscription = (upgradedPlan: any, paymentDetails: any, callback: any) => {
    const fullName = auth?.givenname?.trim() || "";
    const [firstName, ...rest] = fullName?.split(/\s+/);
    const lastName = rest.length > 0 ? rest?.join(" ") : "";

    if (isUpgradingTheSubcription) {
      post_UpgradeSubscription({
        tenantId: tenantId,
        planId: upgradedPlan?.id,
        paymentType: paymentType === 0 ? "Credit Card" : "Bank ACH",
        paymentId: paymentDetails?.id > 0 ? paymentDetails?.id : 0,
        creditCardPayment: paymentType === 0
          ? {
            creditCardNumber: paymentDetails?.creditCardNumber,
            cardHolderName: paymentDetails?.cardholderName,
            ccvCode: paymentDetails?.ccvCode,
            expirationDate: paymentDetails?.expirationDate
          }
          : null,
        achPayment: paymentType === 1
          ? {
            bankName: paymentDetails?.bankName,
            accountNumber: paymentDetails?.accountNumber,
            accountType: paymentDetails?.accountType,
            routingNumber: paymentDetails?.routingNumber,
            bankPhone: paymentDetails?.bankPhone,
            accountHolderName: paymentDetails?.accountHolderName,
            useAccountInfoInFuture: paymentDetails?.useAccountInfoInFuture,
            signedAcknowledgement: paymentDetails?.signedAcknowledgement
          }
          : null,
        userName: auth?.userName,
        firstName: firstName,
        lastName: lastName
      })
        .then(() => {
          setIsRefreshSubscriptionDetails(true);
          setIsRefreshInvoice(true);
          setIsRefreshCreditCardDetails(true);
          setIsRefreshACHDetails(true);

          setIsProcessing(false);
          setIsUpgradingTheSubcription(false);
          setPaymentType(0);
          handleTenantError(null);
          setRefreshTheSubscription(true);

          callback();
        })
        .catch(error => {
          handleTenantError(error);
          const errorMessage = error?.response?.data || error?.message || "File upload failed.";
          setConfirmData({
            title: 'Warning',
            summary: errorMessage,
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });
          setConfirmPopup(true);
          setIsProcessing(false);
        })
    } else {
      post_RenewSubscription({
        tenantId: tenantId,
        paymentType: paymentType === 0 ? "Credit Card" : "Bank ACH",
        paymentId: paymentDetails?.id > 0 ? paymentDetails?.id : 0,
        creditCardPayment: paymentType === 0
          ? {
            creditCardNumber: paymentDetails?.creditCardNumber,
            cardHolderName: paymentDetails?.cardholderName,
            ccvCode: paymentDetails?.ccvCode,
            expirationDate: paymentDetails?.expirationDate
          }
          : null,
        achPayment: paymentType === 1
          ? {
            bankName: paymentDetails?.bankName,
            accountNumber: paymentDetails?.accountNumber,
            accountType: paymentDetails?.accountType,
            routingNumber: paymentDetails?.routingNumber,
            bankPhone: paymentDetails?.bankPhone,
            accountHolderName: paymentDetails?.accountHolderName,
            useAccountInfoInFuture: paymentDetails?.useAccountInfoInFuture,
            signedAcknowledgement: paymentDetails?.signedAcknowledgement
          }
          : null,
        userName: auth?.userName,
        firstName: firstName,
        lastName: lastName
      })
        .then(() => {
          setIsRefreshSubscriptionDetails(true);
          setIsRefreshInvoice(true);
          setIsRefreshCreditCardDetails(true);
          setIsRefreshACHDetails(true);

          setIsProcessing(false);
          setIsUpgradingTheSubcription(false);
          setPaymentType(0);
          handleTenantError(null);
          setRefreshTheSubscription(true);

          callback();
        })
        .catch(error => {
          handleTenantError(error);
          const errorMessage = error?.response?.data || error?.message || "File upload failed.";
          setConfirmData({
            title: 'Warning',
            summary: errorMessage,
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });
          setConfirmPopup(true);
          setIsProcessing(false);
        })
    }
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="w-full mt-2">
          <div className={`w-full pb-4`}>
            <div className="flex flex-col md:flex-row gap-8 w-full">
              <div className="md:w-2/5 w-full flex flex-col gap-6">
                <BillingAddress
                  setShowPopupUpdateBillingAddress={setShowPopupUpdateBillingAddress}
                  billingAddressData={billingAddressData}
                  setBillingAddressData={setBillingAddressData}
                />

                <CreditCardDetails
                  isRefresh={isRefreshCreditCardDetails}
                  setIsRefresh={setIsRefreshCreditCardDetails}
                  setShowPopupAddNewCreditCard={setShowPopupAddNewCreditCard}
                />
              </div>

              <div className="flex-1 flex flex-col gap-6">
                <SubscriptionDetails
                  setShowPopupUpgradeSubscription={setShowPopupUpgradeSubscription}
                  planDetails={planDetails}
                  setPlanDetails={setPlanDetails}
                  paymentType={paymentType}
                  setPaymentType={setPaymentType}
                  isProcessing={isProcessing}
                  setIsProcessing={setIsProcessing}
                  setShowPopupForPayment={setShowPopupForPayment}
                  isRefreshSubscriptionDetails={isRefreshSubscriptionDetails}
                  setIsRefreshSubscriptionDetails={setIsRefreshSubscriptionDetails}
                  setActivePaymentDetails={setActivePaymentDetails}
                  isUpgradingTheSubcription={isUpgradingTheSubcription}
                  setIsUpgradingTheSubcription={setIsUpgradingTheSubcription}
                  callTheAPIForUpgradeSubscription={callTheAPIForUpgradeSubscription}
                />

                <Invoice
                  isRefresh={isRefreshInvoice}
                  setIsRefresh={setIsRefreshInvoice}
                />

                <ACHDetails
                  isRefresh={isRefreshACHDetails}
                  setIsRefresh={setIsRefreshACHDetails}
                  setShowPopupAddNewACH={setShowPopupAddNewACH}
                />
              </div>
            </div>
          </div>
        </div>

        <UpdateBillingAddress
          showPopupUpdateBillingAddress={showPopupUpdateBillingAddress}
          setShowPopupUpdateBillingAddress={setShowPopupUpdateBillingAddress}
          billingAddressData={billingAddressData}
          setBillingAddressData={setBillingAddressData}
        />

        <AddCreditCard
          showPopupAddNewCreditCard={showPopupAddNewCreditCard}
          setShowPopupAddNewCreditCard={setShowPopupAddNewCreditCard}
          setIsRefresh={setIsRefreshCreditCardDetails}
        />

        <AddACH
          showPopupAddNewACH={showPopupAddNewACH}
          setShowPopupAddNewACH={setShowPopupAddNewACH}
          setIsRefresh={setIsRefreshACHDetails}
        />

        <UpgradeSubscription
          showPopupUpgradeSubscription={showPopupUpgradeSubscription}
          setShowPopupUpgradeSubscription={setShowPopupUpgradeSubscription}
          planDetails={planDetails}
          setShowPopupForPayment={setShowPopupForPayment}
          setUpgradePlan={setUpgradePlan}
          activePaymentDetails={activePaymentDetails}
          isProcessing={isProcessing}
          setIsProcessing={setIsProcessing}
          callTheAPIForUpgradeSubscription={callTheAPIForUpgradeSubscription}
        />

        <UpgradePlan
          showPopupForPayment={showPopupForPayment}
          setShowPopupForPayment={setShowPopupForPayment}
          upgradPlan={upgradPlan}
          isProcessing={isProcessing}
          setIsProcessing={setIsProcessing}
          callTheAPIForUpgradeSubscription={callTheAPIForUpgradeSubscription}
          paymentType={paymentType}
          setIsRefresh={setIsRefreshCreditCardDetails}
        />
      </div>
    </div>
  )
}

export default Billing
